import React from "react";
import PropTypes from "prop-types";
import Slider from "react-slick";
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from "react-redux";

import Component from "components/component";
import DefaultOption from "./default-option";
import DefaultOptionSelection from "./default-option-selection";
import SelectionPrompt from "./selection-prompt";
import {
  isSelectable,
  shouldOptionRowUpdate,
} from "../../lib/helpers";
import ComDetailsForm from "./com-details-form";

const settings = {
  speed: 500,
  dots: false,
  arrows: false,
  infinite: false,
  draggable: true,
  focusOnSelect: false,
  slidesToShow: 3,
  swipeToSlide: true,
  centerMode: false
};

class FabricOptionRow extends Component {
  static propTypes = {
    optionType: ImmutablePropTypes.map,
    optionValues: ImmutablePropTypes.map,
    selection: ImmutablePropTypes.map,
    handleClick: PropTypes.func.isRequired,
    selections: ImmutablePropTypes.map,
    optionValueRestrictions: ImmutablePropTypes.map,
    isStaffUser: PropTypes.bool.isRequired,
    quantityCount: PropTypes.number.isRequired,
    editComDetailField: PropTypes.func.isRequired,
    comDetail: PropTypes.object,
    userRole: PropTypes.string,
  };

  constructor(props) {
    super(props);
    this.state = { isOpen: false, showAdditionalOptions: false };

    const { optionValues } = this.props;
    let name;
    if (props.userRole === 'retail_user' || props.userRole === '') {
      name = "fabric_com";
    }

    this.customerOwnedFabrics = filterByCollection(
      optionValues,
      FABRIC_CUSTOMER_OWNED,
      name,
    );

    this.coreFabrics = filterByCollection(
      optionValues,
      FABRIC_CORE_COLLECTION
    );

    this.nonCoreFabrics = filterByCollection(
      optionValues,
      FABRIC_ADDITIONAL_COLLECTION
    );
    this.allFabrics = this.coreFabrics.concat(
      this.customerOwnedFabrics,
      this.nonCoreFabrics
    );
  }

  shouldComponentUpdate(newProps, newState) {
    return shouldOptionRowUpdate(newProps, newState, this);
  }

  toggleOpen = e => {
    if (e) e.preventDefault();
    this.setState({ isOpen: !this.state.isOpen });
  };

  showMore = e => {
    e.preventDefault();
    this.setState({ showAdditionalOptions: true });
  };

  UNSAFE_componentDidUpdate(oldProps, oldState) {
    if (!oldState.isOpen && this.state.isOpen) {
      const selection = this.props.selection;
      const selectionIsPresent = !!selection;

      if (selectionIsPresent) {
        const selectionCollection = selection.getIn(["metaData", "collection"]);
        const refName = `${selectionCollection}Slider`;
        this.refs[refName].slickGoTo(this.refs[refName].props.slickGoTo);
      }
    }
  }

  renderCollection(collection, renderInSlider = false) {
    const {
      selection,
      handleClick,
      selections,
      optionValueRestrictions
    } = this.props;
    const selectionId = selection.get("id");

    return collection.valueSeq().map((optionValue, i) => {
      const id = optionValue.get("id");
      const selectable = isSelectable(selections, optionValueRestrictions, id);
      const displayUpchargeAmount = getFabricDisplayUpchargeAmount(optionValue);

      let props = {
        key: id,
        optionValue,
        isSelected: selectionId === id,
        handleClick,
        selectable,
        noMargin: false
      };

      if (renderInSlider) {
        return (
          <div key={id}>
            <DefaultOption
              {...props}
              displayUpchargeAmountOverride={displayUpchargeAmount}
              inSlider
            />
          </div>
        );
      }

      if ((i + 1) % 3 === 0) {
        props.noMargin = true;
      }

      return (
        <DefaultOption
          {...props}
          displayUpchargeAmountOverride={displayUpchargeAmount}
        />
      );
    });
  }

  render() {
    if (this.props.optionValues.isEmpty()) return null;

    const { isOpen, showAdditionalOptions } = this.state;
    const { optionType, selection, isStaffUser, quantityCount, comDetail, userRole } = this.props;

    const optionName = optionType.get("displayName");
    const toggleClass = isOpen ? "toggle-row open" : "toggle-row";
    const selectionIsPresent = !!selection;
    const allowAdditionalFabricSelection = isStaffUser;

    let selectionName,
      selectionUpchargeAmount,
      selectionImage,
      selectionId,
      selectionCollection;

    if (selectionIsPresent) {
      selectionName = selection.get("displayName");
      selectionId = selection.get("id");
      selectionUpchargeAmount = selection.get("upchargeAmount");
      selectionImage = selection.get("thumbnailImage");
      selectionCollection = selection.getIn(["metaData", "collection"]);
    }

    let comDetailValues = comDetail;

    return (
      <div>
        <div className="product-options-title-row desktop-only">
          <p className="lined-title">
            <span>{optionName}</span>
          </p>
        </div>

        <div className="product-options-row three-option-columns fabric-row">
          <div className="product-options-wrapper-mobile mobile-only">
            <a href="#" className={toggleClass} onClick={this.toggleOpen} />

            {!isOpen && !selectionIsPresent && (
              <div>
                <p className="option-name">{optionName}</p>
                <SelectionPrompt name={selectionName} />
              </div>
            )}

            {!isOpen && selectionIsPresent && (
              <DefaultOptionSelection
                optionName={optionName}
                selectionName={selectionName}
                upchargeAmount={selectionUpchargeAmount}
                thumbnailImage={selectionImage}
                displayUpchargeAmountOverride={getFabricDisplayUpchargeAmount(
                  selection
                )}
                displaySummaryFabricPrice={getFabricDisplaySummaryPrice(
                  selection
                )}
                quantityCount={quantityCount}
                showQuantity={
                  selectionUpchargeAmount > 0 && quantityCount > 1
                }
                isFabric
              />
            )}

            <div style={{ display: isOpen ? "block" : "none" }}>
              <p className="option-name">{optionName}</p>

              <div>
                <p>{FABRIC_CORE_COLLECTION}</p>

                <div className="product-options-slider-wrapper">
                  <Slider
                    {...settings}
                    slickGoTo={selectionIndexFor(
                      selectionId,
                      selectionCollection,
                      FABRIC_CORE_COLLECTION,
                      this.coreFabrics
                    )}
                    ref={`${FABRIC_CORE_COLLECTION}Slider`}
                  >
                    {this.renderCollection(this.coreFabrics, true)}
                  </Slider>
                </div>

                {this.customerOwnedFabrics.size > 0 && (
                  <React.Fragment>
                    <p>{FABRIC_CUSTOMER_OWNED}</p>

                    <div className="product-options-slider-wrapper">
                      <Slider
                        {...settings}
                        slickGoTo={selectionIndexFor(
                          selectionId,
                          selectionCollection,
                          FABRIC_CUSTOMER_OWNED,
                          this.customerOwnedFabrics
                        )}
                        ref={`${FABRIC_CUSTOMER_OWNED}Slider`}
                      >
                        {this.renderCollection(this.customerOwnedFabrics, true)}
                      </Slider>
                      <div>
                        {['fabric_com', 'fabric_col', 'specialty_com'].includes(this.props.selection.get('name')) && (
                          <ComDetailsForm
                            editComDetailField={this.props.editComDetailField}
                            {...comDetailValues}
                            type={this.props.selection.get('name')}
                          />
                        )}
                        <div className="footnote">
                          *Lead time will commence upon receipt of all backed COM.
                        </div>
                      </div>
                    </div>
                  </React.Fragment>
                )}

                {showAdditionalOptions && (
                  <div>
                    <p>{FABRIC_ADDITIONAL_COLLECTION}</p>

                    <div className="product-options-slider-wrapper">
                      <Slider
                        {...settings}
                        slickGoTo={selectionIndexFor(
                          selectionId,
                          selectionCollection,
                          FABRIC_ADDITIONAL_COLLECTION,
                          this.nonCoreFabrics
                        )}
                        ref={`${FABRIC_ADDITIONAL_COLLECTION}Slider`}
                      >
                        {this.renderCollection(this.nonCoreFabrics, true)}
                      </Slider>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="desktop-only clearfix">
            <div className="fabric-collection-wrapper">
              <div className="options-container fabric-collection">
                {this.renderCollection(this.coreFabrics)}
              </div>
            </div>

            {this.customerOwnedFabrics.size > 0 && (
              <div className="fabric-collection-wrapper">
                <div className="collection-header">
                  <h3 className="collection-headline">Customer's Own Material</h3>
                </div>

                <div className="options-container fabric-collection customers-own">
                  {this.renderCollection(this.customerOwnedFabrics)}
                </div>
                <div>
                  {['fabric_com', 'fabric_col', 'specialty_com'].includes(this.props.selection.get('name')) && (
                    <ComDetailsForm
                      editComDetailField={this.props.editComDetailField}
                      {...comDetailValues}
                      type={this.props.selection.get('name')}
                    />
                  )}
                  <div className="footnote">
                    *Lead time will commence upon receipt of all backed COM.
                  </div>
                </div>

                {(userRole !== 'trade_user') && (
                  <div className="customization-notice-wrapper desktop-only" style={{marginTop: 50}}>
                    <p className="customization-notice-subheader">
                      Customer's Own Material (COM) must be provided for order placement.<br />
                      Please <a href="/contact" className="customization-notice-link">contact</a> our showroom for further details.
                    </p>
                  </div>
                )}
              </div>
            )}

            {allowAdditionalFabricSelection &&
              !showAdditionalOptions &&
              this.nonCoreFabrics.size > 0 &&
              (
                <button
                  className="show-more-button large center"
                  onClick={this.showMore}
                >
                  Show Additional Collections
                </button>
              )}

            {allowAdditionalFabricSelection && (
              <div className="additional-options">
                {showAdditionalOptions && (
                  <div>
                    <div className="fabric-collection-wrapper">
                      <div className="collection-header">
                        <h3 className="collection-headline">
                          Dmitriy & Co Non-Core Collection
                        </h3>
                      </div>
                      <div className="options-container fabric-collection">
                        {this.renderCollection(this.nonCoreFabrics)}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

function filterByCollection(fabrics, collection, name) {
  return fabrics
    .filter(f => {
      return f.getIn(["metaData", "collection"]) === collection;
    })
    .filter(f => {
      if (name) {
        return f.getIn(["name"]) === name;
      }

      return true;
    })
    .sortBy(f => f.get("displayName"));
}

function getFabricDisplayUpchargeAmount(optionValue) {
  if (!optionValue) {
    return null;
  }

  const collection = optionValue.getIn(["metaData", "collection"]);

  if (
    [FABRIC_CUSTOMER_OWNED, FABRIC_CORE_COLLECTION].indexOf(collection) > -1
  ) {
    return "+$0";
  }

  if (
    [FABRIC_ADDITIONAL_COLLECTION, FABRIC_LORO_PIANA_COLLECTION].indexOf(
      collection
    ) > -1
  ) {
    return `${optionValue.get("displayUpchargeAmount")}/yard`;
  }

  return null;
}

function selectionIndexFor(
  selectionId,
  selectionCollection,
  collectionName,
  collectionFabrics
) {
  if (selectionCollection !== collectionName) {
    return "";
  }

  return collectionFabrics.valueSeq().findIndex(f => {
    return f.get("id") === selectionId;
  });
}

function getFabricDisplaySummaryPrice(optionValue) {
  if (!optionValue) {
    return null;
  }

  const collection = optionValue.getIn(["metaData", "collection"]);

  if (
    [FABRIC_CUSTOMER_OWNED, FABRIC_CORE_COLLECTION].indexOf(collection) > -1
  ) {
    return "+$0";
  }

  if (
    [FABRIC_ADDITIONAL_COLLECTION, FABRIC_LORO_PIANA_COLLECTION].indexOf(
      collection
    ) > -1
  ) {
    const amt = optionValue.get("upchargeAmount") / 100.0;
    return `$${amt}`;
  }

  return null;
}

function mapStateToProps(state) {
  const { userRole } = state.userStore.toObject();
  return {
    userRole
  }
}

export default connect(
  mapStateToProps
)(FabricOptionRow);
